import * as React from 'react';
import { formatMoney } from '../../../utils';
import dayjs from 'dayjs';
import { IInvoice } from '../../../@types';
import { Table } from '../../common';
import { Link} from 'react-router-dom';
import { BankData } from '../../../types';
import { Statuses  } from '../../../constants';
import InvoiceDocumentTable from '../invoiceDocumentTable';

interface InvoiceDocumentProps {
  invoice: IInvoice;
  address: string;
  bankData: BankData[] ;
}

const InvoiceDocument: React.FC<InvoiceDocumentProps> = ({ invoice, address, bankData }) => {
  const [isLoading] = React.useState(false);


  if (!invoice) {
    return null;
  }
 
  const data = invoice.inventories.map((inv: any, i: any) => ([
    i + 1,
    inv.name,
    inv?.quantity,
    inv?.rate,
    formatMoney(`${parseInt(inv.rate) * parseInt(inv.quantity)}`, invoice.currency),
  ]));
  

  const mobileData = invoice.inventories.map((inv: any, i: any) => ({
    name: inv.name,
    quantity: inv?.quantity,amount: formatMoney(
      `${parseInt(inv.rate) * parseInt(inv.quantity)}`,
      invoice.currency
    ),
    
  }));
  
  const columns = ['#', 'Item(s)/Description', 'Qty', 'Rate', 'Amount']


  const renderLineItemsMobileTableHead = () => {
    return {
      name: { title: 'Item' },
      quantity: { title: 'Qty' },
      amount: { title: 'Amount' },
    };
  };

  const subTotal = invoice.inventories
    .map((inv: any) => {
      const rate = parseInt(inv.rate);
      const quantity = parseInt(inv.quantity);

      if (isNaN(rate) || isNaN(quantity)) {
        return 0;
      }

      return rate * quantity;
    })
    .reduce((prev: any, curr: any) => prev + curr, 0);

  let discount = invoice.discount !== undefined ? subTotal * invoice.discount : 0;
  let tax = invoice.tax !== undefined ? subTotal * invoice.tax : 0;
  let total = subTotal - discount + tax;
   const minHeight = '850px'; 
   const tableHeight = `${data.length * 500}px`; 
   const containerHeight = tableHeight > minHeight ? tableHeight : minHeight;
  

  return (
    <>
    {/* Mobile screens */}
    
<div className='flex justify-center'>
  <div className="bg-white h-full block md:hidden w-[125%] mx-auto py-[2em] lg:w-full">
      <div className='mx-auto'>
        <div className="flex justify-between  items-center">
          <div className="">
            {address ? (
              <>
                <p className="w-[110px] mt-5 text-[11px] ml-[1em]">{address}</p>
              </>
            ) : (
              <>
                <p className='text-[11px] ml-3 sm:text-[11px]'>No Address Yet.</p>
           
            <Link to="/settings" className="text-red-500 ml-3 text-[60%] md:text-[80%] hover:underline">
              Kindly Go to Settings
            </Link>
            </>
            )}
          </div>
              <div className="mx-3 text-left font-semibold">
              <span className="text-[14px] font-semibold">INVOICE</span>
              <p className="text-[14px]">{invoice.invoiceNumber}</p>
              {invoice.status === Statuses.PAID  ? "" : (
                <>
                 <p className='text-[12px] sm:text-[12px] md:text-[12px]'>Balance Due</p>
                <p className='text-[12px] sm:text-[12px] md:text-[12px]  '> {formatMoney(invoice.balanceDue, invoice.currency)}</p>
                </>
              )
              }
            </div>
          </div>

        <hr className='my-5 mx-2'/>
    
          <div className="flex justify-between">

            <div className="ml-3">
            <p className="font-normal font-[11px] mb-3">Bill to</p>
            <div className="leading-5">
              <p className="mb-2 font-semibold text-[#000000] not-italic text-[13px] leading-6 tracking-wide md:text-[13px] sm:text-[13px]">{invoice.customer.firstName + ' ' + invoice.customer.lastName}.</p>
              <p className="w-[150px] text-[11px] font-normal">{invoice.customer.address}</p>
            </div>
            </div>
        
            <div className='flex flex-col mr-3 gap-4'>
              <div className="flex flex-col text-right">
                <p className='font-light text-[#000000] not-italic  text-[11px] leading-6 tracking-wide sm:text-[70%]  md:text-[80%]'>Invoice Date</p>
                <p className='font-normal text-[#000000] not-italic  text-[11px] leading-6 tracking-wide sm:text-[70%] md:text-[80%]'>{dayjs(invoice.createdAt).format('DD MMMM, YYYY')}</p>
              </div>
              <div className="flex flex-col text-right">
                <p className='font-light text-[#000000] not-italic  text-[11px] leading-6 tracking-wide sm:text-[70%] md:text-[80%]'>Due Date:</p>
                <p className='font-normal text-[#000000] not-italic  text-[11px] leading-6 tracking-wide sm:text-[70%] md:text-[80%]'>{dayjs(invoice.invoiceDueAt).format('DD MMMM, YYYY')}</p>
              </div>
            </div>
          </div>
          <hr className='mt-5 mx-2'/>

       <div className='' >
          <Table
            searchPlaceHolder="Search"
            hideFloatingScrollButton={true}
            searchDisplayKey={'invoiceNumber'}
            searchResult={[]}
            head={renderLineItemsMobileTableHead()}
            data={mobileData}
            showMobileInvoiceTable={true}
            isLoading={isLoading}
            buttons={[]}
          />
        </div>

        <div className="mt-[20px] ">
          <div className=''>
            <div className="text-left mr-[]">
            <div className="flex justify-end gap-[10em] 540:gap-[17em] text-[11px] px-[1em]">
              <p className='font-normal text-left text-[#000000] not-italic  text-[11px] leading-6 tracking-wide  sm:text-[11px] '>Sub Total:</p>
              <p>{formatMoney(subTotal, invoice.currency)}</p>
            </div>
            <div className="flex justify-end gap-[12em] 540:gap-[19em] text-[11px] px-[1em] ">
              <p className='font-normal  text-left text-[#000000] not-italic  text-[11px] leading-6 tracking-wide  sm:text-[11px]'>Discount:</p>
              <p>{formatMoney(discount, invoice.currency)}</p>
            </div>
            <div className="flex justify-end gap-[13em] 540:gap-[20em] text-[11px] px-[1em] ">
              <p className='font-normal text-left text-[#000000] not-italic  text-xs leading-6 tracking-wide  sm:text-[11px]'>VAT:</p>
              <p>{formatMoney(tax, invoice.currency)}</p>
            </div>
          <div className='border max-w-[1200px] ml-[-25em]' ></div>
            <div className="flex justify-end  gap-[10em] 540:gap-[17em] px-[1em] mt-[20px] font-semibold text-[11px] text-left ">
              <p className='text-[#044E97] text-[11px]'>Total(NGN)</p>
              <p className='text-[#044E97] font-semibold'>{formatMoney(total, invoice.currency)}</p>
            </div>
            <div className="flex justify-end  gap-[12em] 540:gap-[17em] px-[1em] text-[11px] text-left">
              <p className="font-semibold">Balance Due</p>
              <p className="font-semibold">{formatMoney(invoice.balanceDue, invoice.currency)}</p>
            </div>
          </div>
          </div>
          
          </div>
          <div className=" bg-white  px-[1em] text-[12px] mt-[1em] ">
          {bankData && bankData.length > 0 ? (
            <>
              {bankData.map((bank: BankData, index: number) => (
                <p className="max-w-[650px] my-3" key={index}>
                  Payment Details: {bank.accountNumber} | {bank.accountName} | {bank.bankName}
                </p>
              ))}
            </>
          ) : (
            <span className='px-[1em] py-[1em]'>
              Please&nbsp;
              <Link to="/settings?tab=bankAccount" className="text-red-500 hover:underline">
                Go to Settings
              </Link>
              &nbsp;to add your bank account
            </span>
          )}
        </div>
        </div>
        </div>
</div>
    
{/* Desktop screens */}
    <div className="mx-auto h-full bg-white  hidden lg:ml-0 md:block" id="invoice-document">
    {/* Invoice Itself */}
    <div className=" xl:mx-0 px-[80px] py-[50px] lg:w-[700px] biglg:w-[850px] xl:w-[946px] 2xl:w-[1024px] "  style={{ height: containerHeight }}>
      <div className="">
        <div className="flex justify-between items-center">
          <div className="">
            {address ? (
              <>
                <p className="w-[110px] mt-5 text-[17.25px]">{address}</p>
              </>
            ) : (
              <>
                <p>No Address Yet.</p>
           
            <Link to="/settings" className="text-red-500 hover:underline">
              Kindly Go to Settings
            </Link>
            </>
            )}
          </div>
              <div className="text-right">
              <span className="text-[47.44px] font-normal">INVOICE</span>
              <p className="text-[28.75px]">{invoice.invoiceNumber}</p>
              {invoice.status === Statuses.PAID.toLowerCase()  ? "" : (
                <>
                 <p className='text-[23.003px]'>Balance Due</p>
                <p className='text-[23.003px]  '> {formatMoney(invoice.balanceDue, invoice.currency)}</p>
                </>
              )
              }
            </div>
          </div>
        </div>

        <div className="mt-10">
          <div>
            <p className="font-normal mb-3 text-[20.128px] pb-[39.26px]">Bill to</p>
          </div>
          <div className="flex justify-between">
            <div className="leading-5 text-[17.252px]">
              <p className="mb-2">{invoice.customer.firstName + ' ' + invoice.customer.lastName}.</p>
              <p className="w-[150px]">{invoice.customer.address}</p>
            </div>

            <div className='text-[17.252px] mt-[-1em] '>
              <div className="flex gap-[5em] pb-[17px]">
                <p>Invoice Date:</p>
                <p className='text-right'>{dayjs(invoice.issueDate).format('DD MMMM, YYYY')}</p>
              </div>
              <div className="flex gap-[6.3em]">
                <p>Due Date:</p>
                <p className='text-right'>{dayjs(invoice.invoiceDueAt).format('DD MMMM, YYYY')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 h-"></div>

        <div className='' style={{ overflowX: 'auto' }}>
        <InvoiceDocumentTable 
        columns={columns} 
        data={data} 
        />
         </div>

        <div className="mt-[40px] ">
          <div className="float-right md:ml-0 lg:ml-0 ">
            <div className="flex justify-between  pl-[4em] pr-[1.5em] lg:text-[23px] md:text-[14px] ">
              <p>Sub Total:</p>
              <p className='text-right'>{formatMoney(subTotal, invoice.currency)}</p>
            </div>
            <div className="flex justify-between pl-[4em] pr-[1.5em] lg:text-[23px] md:text-[14px]  ">
              <p>Discount:</p>
              <p>{formatMoney(discount, invoice.currency)}</p>
            </div>
            <div className="flex justify-between pl-[4em] pr-[1.5em] lg:text-[23px] md:text-[14px] ">
              <p>VAT:</p>
              <p>{formatMoney(tax, invoice.currency)}</p>
            </div>

            <div className="flex justify-between pl-[4em] pr-[1.5em] font-semibold lg:text-[23px] md:text-[14px]">
              <p>Total(NGN):</p>
              <p>{formatMoney(total, invoice.currency)}</p>
            </div>
         
            <div className=" bg-[#044e9726] md:ml-[3em] xl:ml lg:w-[423px] pr-[1.5em] md:w-[271px] md:h-[50px] lg:h-[70px] flex justify-between gap-[6.2em] px-[1em] font-semibold py-[1em] top-0 left-0 rounded-[5.75px] lg:text-[23px] md:text-[14px]">
              <p className=""style={{ whiteSpace: 'nowrap' }}>Balance Due:</p>
              <p className='lg:text-[23px] text-[19px]'>{formatMoney(invoice.balanceDue, invoice.currency)}</p>
            </div>
      
          </div>
          </div>
          </div>
      
        <div className='bg-white border-t bottom-0 px-[] py-[1em] h-[90px] mt-[9em] text-[16px] '>
          {bankData && bankData.length > 0 ? (
            <>
              {bankData.map((bank: BankData, index: number) => (
                <p className="w-[100px] ml-[1em] whitespace-nowrap" key={index}>
                  Payment Details: {bank.accountNumber} | {bank.accountName} | {bank.bankName}
                </p>
              ))}
            </>
          ) : (
            <span className='px-[1em] py-[3em]' style={{ whiteSpace: 'nowrap' }}>
              Please&nbsp;
              <Link to="/settings?tab=bankAccount" className="text-red-500 hover:underline">
                Go to Settings
              </Link>
              &nbsp;to add your bank account
            </span>
          )}
        </div>
        
    </div>
    </>
    
   
  );
};

export { InvoiceDocument };
